import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, d as _extends, c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement, Component } from 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import { findDOMNode } from 'react-dom';
import { a as hoist } from './chunk-0cd02bff.js';
import './chunk-11bd1c20.js';
import './Hidden.js';
import 'constate';
import './chunk-061cef7c.js';
import './chunk-22b2fb47.js';
import 'styled-selector';
import 'popper.js';
import { a as PopoverArrow } from './chunk-0599225e.js';
import Popover from './Popover.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TooltipComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TooltipComponent, _React$Component);

  function TooltipComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isControlled", function () {
      return typeof _this.props.visible !== "undefined";
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "show", function () {
      return _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hide", function () {
      return _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTooltip", function () {
      return findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
    });

    return _this;
  }

  var _proto = TooltipComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$getTooltip = this.getTooltip(),
        parentNode = _this$getTooltip.parentNode;

    if (parentNode && !this.isControlled()) {
      parentNode.addEventListener("mouseenter", this.show);
      parentNode.addEventListener("focus", this.show);
      parentNode.addEventListener("mouseleave", this.hide);
      parentNode.addEventListener("blur", this.hide);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$getTooltip2 = this.getTooltip(),
        parentNode = _this$getTooltip2.parentNode;

    if (parentNode) {
      parentNode.removeEventListener("mouseenter", this.show);
      parentNode.removeEventListener("focus", this.show);
      parentNode.removeEventListener("mouseleave", this.hide);
      parentNode.removeEventListener("blur", this.hide);
    }
  };

  _proto.render = function render() {
    var _ref = this.isControlled() ? this.props : this.state,
        visible = _ref.visible;

    return createElement(Popover, _extends({}, this.props, {
      visible: visible
    }));
  };

  return TooltipComponent;
}(Component);

var Tooltip = styled(hoist(TooltipComponent, Popover))(_templateObject(), theme("Tooltip"));
Tooltip.defaultProps = {
  role: "tooltip",
  placement: "top",
  opaque: true,
  palette: "grayscale"
};
var Tooltip$1 = use(Tooltip, "div");

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var TooltipArrow = styled(PopoverArrow)(_templateObject$1(), theme("TooltipArrow"));
TooltipArrow.defaultProps = {
  palette: "grayscale"
};
var TooltipArrow$1 = use(TooltipArrow, "div");

var index = Object.assign(Tooltip$1, {
  Arrow: TooltipArrow$1
});

export default index;
